import { render } from "./AffiliateSection.vue?vue&type=template&id=2827939b"
import script from "./AffiliateSection.vue?vue&type=script&lang=js"
export * from "./AffiliateSection.vue?vue&type=script&lang=js"

import exportComponent from "/media/wasiq/01D86AE721474C60/Work/new-animation-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__